import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher'
import { debounce } from './common';
//import * as $ from 'jquery';
import $ from 'jquery';

export default class SearchBar {
    private baseElement: HTMLInputElement;
    private debounceDelay: number;
    private minChars: number;

    init(): void {
        this.baseElement = document.querySelector('#js-search-autocomplete-input');
        this.debounceDelay = Number(this.baseElement.getAttribute('data-wait-debounce'));
        this.minChars = Number(this.baseElement.getAttribute('data-min-chars'));
        $(this.baseElement).on('input', debounce(() => {
            var val = $('#js-search-autocomplete-input').val() as string;

            if (val && val.length >= this.minChars) {
                var action = new ActionCreator().searchAction(val);
                new AjaxDispatcher().dispatchGetAction(action);
            } else {
                $('[data-component="SearchBarResult"]').empty();
            }
        }, this.debounceDelay, false));

    }

}
